var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted, ref, computed } from "vue";
import JsonDrawer from "src/shared/v-components/ui/drawer/JsonDrawer.vue";
import axios from "axios";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DebugDrawer',
    props: {
        url: {},
        isShown: { type: Boolean }
    },
    emits: ["update:isShown"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const logs = ref({});
        const emit = __emit;
        const onClose = () => {
            emit("update:isShown", false);
        };
        const parseAndFormatLog = (logString) => {
            const entries = logString.split(/,\s+(?=\w+?:)/);
            const groups = {};
            for (const entry of entries) {
                const match = entry.match(/^(\w+?)(?::|\s)/);
                const key = match ? match[1] : "General";
                if (!groups[key]) {
                    groups[key] = [];
                }
                groups[key].push(entry.trim());
            }
            return groups;
        };
        const parsedUrl = computed(() => {
            var _a;
            return (_a = props.url) === null || _a === void 0 ? void 0 : _a.replace("/core/preview.html", "");
        });
        const fetchDebugLogs = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!parsedUrl.value) {
                return;
            }
            try {
                const response = yield axios.get(parsedUrl.value, {
                    headers: {
                        "X-Extole-Debug": "true",
                    },
                });
                const logHeader = response.headers["x-extole-log"] || "";
                if (logHeader) {
                    logs.value = parseAndFormatLog(logHeader);
                }
                else {
                    logs.value = {};
                }
            }
            catch (error) {
                if (axios.isAxiosError(error)) {
                    throw new Error(`Request failed with status ${((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) || "unknown"}`);
                }
                throw error;
            }
        });
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            yield fetchDebugLogs();
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(JsonDrawer, {
                data: logs.value,
                title: 'Extole Debug Logs',
                onClosed: onClose
            }, null, 8 /* PROPS */, ["data"]));
        };
    }
});
